import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// right side stepper states
const steps = [
  {
    label: "Feature Definition and Traits",
    doctype: "",
    title:
      "This should be a tailored document for LLM to consume capturing comprehensive Feature description information. E.g. select content from Feature concepts, characteristics, feature overview, BizRevs, RIB, Product concept form, product initiation form etc. ",
  },
  {
    label: "Feature Needs with Rationale",
    doctype: "Generate Feature Needs with Rationale",
    title:
      "To generate Feature Needs, please load Feature Definition document(s).",
  },
  {
    label: "Use Cases",
    doctype: "Generate Use cases",
    title:
      "To generate Use Cases, please load Feature Needs and other relevant documents",
  },
  {
    label: "Feature Requirements with Rationale",
    doctype: "Generate Feature Requirements with Rationale",
    title:
      "To generate Feature Requirements, please load Feature Needs and Use cases. Also load wireframes if any, as appropriate",
  },
  {
    label: "User Stories",
    doctype: "Generate User Stories",
    title:
      "To generate User Stories, please load Feature Requirements file at a minimum",
  },
  {
    label: "Test Cases Steps",
    doctype: "Generate Test Case Steps",
    title:
      "To generare Test Case Steps, please load Feature Requirements and User Stories documents at a minimum",
  },
  {
    label: "Acceptance Criteria & Expected Results",
    doctype: "Generate Acceptance Criteria & Expected Results",
    title:
      "To generate Acceptance Criteria and Expected Results, please load Feature Requirements, Test Case Steps, User Stories files at a minimum",
  },
];

export default function VerticalLinearStepper(doctype) {
  const [activeStep, setActiveStep] = React.useState(0);

  useEffect(() => {
    const step = steps.findIndex((step) => step.doctype === doctype?.doctype);
    // console.log(active_step);
    setActiveStep(step);
  }, [doctype]);

  return (
    <Box sx={{ fontSize: "inherit" }}>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        sx={{
          fontSize: "inherit",
          maxHeight: "20px",
          ".MuiStepConnector-line": {
            minHeight: "20px",
          },
          ".MuiSvgIcon-root.Mui-completed": {
            color: "#61CC45",
          },
          ".MuiStepLabel-label.Mui-active": {
            fontWeight: "bolder",
          },
          ".MuiStepLabel-label": {
            fontSize: "inherit",
          },
          ".MuiSvgIcon-root-MuiStepIcon-root ": {
            fontSize: "inherit",
          },
          ".MuiStepIcon-text": {
            fontSize: "1rem",
          },
        }}
      >
        {steps.map((step) => (
          <Step key={step.label} sx={{ fontSize: "inherit" }}>
            <StepLabel
              sx={{
                fontWeight: activeStep === step.label ? "bolder" : "medium",
                fontSize: "inherit",
              }}
            >
              {step.label}
              <Tooltip
                title={step.title}
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: "1rem", // Adjust the font size as needed
                    },
                  },
                }}
              >
                <IconButton>
                  <InfoRoundedIcon sx={{ fontSize: "20px" }} />
                </IconButton>
              </Tooltip>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
